import api from "./axios";

// 신규 저장 (dns 없음)
export const createConstMeta = async (values) => {
  const res = await api.post("const/meta/save/", values);
  return res.data;
};

// 수정 저장 (dns 있음)
export const updateConstMeta = async (dns, values) => {
  const res = await api.post("const/meta/save/", {
    dns,
    ...values,
  });
  return res.data;
};

// ===== 공사일보 =====
export const getWorkReports = (params = {}) =>
  api.get("const/reports/", { params }).then((res) => res.data);

export const getWorkReportDetail = (reportId) =>
  api.get(`const/reports/${reportId}/`).then((res) => res.data);

export const createWorkReport = (data) =>
  api.post("const/reports/create/", data).then((res) => res.data);

export const updateWorkReport = (reportId, data) =>
  api.put(`const/reports/update/${reportId}/`, data).then((res) => res.data);

export const deleteWorkReport = (reportId) =>
  api.delete(`const/reports/delete/${reportId}/`).then((res) => res.data);

// 날씨+프로젝트명
export const getProjectDailyContext = () =>
  api.get(`const/daily/init/`).then((res) => res.data);

// ===== 장비 =====
export const getEquipments = (project) =>
  api.get("const/equipments/", { params: { project } }).then((res) => res.data);

export const getEquipmentDetail = (equipmentId) =>
  api.get(`const/equipments/${equipmentId}/`).then((res) => res.data);

export const createEquipment = (data) =>
  api.post("const/equipments/create/", data).then((res) => res.data);

export const updateEquipment = (equipmentId, data) =>
  api
    .put(`const/equipments/update/${equipmentId}/`, data)
    .then((res) => res.data);

export const deleteEquipment = (equipmentId) =>
  api.delete(`const/equipments/delete/${equipmentId}/`).then((res) => res.data);

// ===== 자재 =====
export const getMaterials = (project) =>
  api.get("const/materials/", { params: { project } }).then((res) => res.data);

export const getMaterialDetail = (materialId) =>
  api.get(`const/materials/${materialId}/`).then((res) => res.data);

export const createMaterial = (data) =>
  api.post("const/materials/create/", data).then((res) => res.data);

export const updateMaterial = (materialId, data) =>
  api
    .put(`const/materials/update/${materialId}/`, data)
    .then((res) => res.data);

export const deleteMaterial = (materialId) =>
  api.delete(`const/materials/delete/${materialId}/`).then((res) => res.data);

// ===== 인원 =====
export const getPersonnels = (project) =>
  api.get("const/personnels/", { params: { project } }).then((res) => res.data);

export const getPersonnelDetail = (personnelId) =>
  api.get(`const/personnels/${personnelId}/`).then((res) => res.data);

export const createPersonnel = (data) =>
  api.post("const/personnels/create/", data).then((res) => res.data);

export const updatePersonnel = (personnelId, data) =>
  api
    .put(`const/personnels/update/${personnelId}/`, data)
    .then((res) => res.data);

export const deletePersonnel = (personnelId) =>
  api.delete(`const/personnels/delete/${personnelId}/`).then((res) => res.data);

// ===== 사용량 (장비/자재/인원) =====
export const getEquipmentUsage = (project, equipmentId, start, end) =>
  api
    .get("const/equipment_usage/", {
      params: { project, equipment_id: equipmentId, start, end },
    })
    .then((res) => res.data);

export const getMaterialUsage = (project, materialId, start, end) =>
  api
    .get("const/material_usage/", {
      params: { project, material_id: materialId, start, end },
    })
    .then((res) => res.data);

export const getPersonnelUsage = (project, personnelId, start, end) =>
  api
    .get("const/personnel_usage/", {
      params: { project, personnel_id: personnelId, start, end },
    })
    .then((res) => res.data);

//여기서부터 user template 관련 함수
// 생성
export const saveUserTemplate = (data) =>
  api.post("const/userTemplates/create/", data).then((res) => res.data);
// 목록 불러오기 (project_id 필요)
export const getUserTemplates = (projectId) =>
  api.get(`const/userTemplates/${projectId}/`).then((res) => res.data);
// 상세
export const getUserTemplate = (templateId) =>
  api.get(`const/userTemplates/detail/${templateId}/`).then((res) => res.data);
// 수정
export const updateUserTemplate = (templateId, data) =>
  api
    .put(`const/userTemplates/update/${templateId}/`, data)
    .then((res) => res.data);
// 삭제
export const deleteUserTemplate = (templateId) =>
  api
    .delete(`const/userTemplates/delete/${templateId}/`)
    .then((res) => res.data);

//여기서부터 주/월간 보고 관련 함수
// 주/월간보고 생성
export const createProgress = (data) => {
  return api
    .post("const/progress/create/", data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res.data);
};

// 주/월간보고 목록 (project_id 필요)
export const getProgressList = (projectId, params = {}) =>
  api.get(`const/progress/${projectId}/`, { params }).then((res) => res.data);

// 주/월간보고 상세 (pk 필요)
export const getProgressDetail = (pk) =>
  api.get(`const/progress/detail/${pk}/`).then((res) => res.data);

// 주/월간보고 수정
export const updateProgress = (pk, data) =>
  api.put(`const/progress/update/${pk}/`, data).then((res) => res.data);
// 주/월간보고 삭제
export const deleteProgress = (pk) =>
  api.delete(`const/progress/delete/${pk}/`).then((res) => res.data);

//시공사진 관련 함수들
// 시공사진 생성
export const createPhoto = (photos, projectId) => {
  const formData = new FormData();

  formData.append("project", projectId);

  const meta = photos.map((p) => ({
    title: p.title,
    activity_id: p.activity_id,
    description: p.description,
  }));
  formData.append("meta", JSON.stringify(meta));

  // 사진
  photos.forEach((p) => {
    formData.append("photos", p.file); // key 이름 "photos" 유지
  });

  return api
    .post("const/photo/create/", formData, {
      headers: { "Content-Type": "multipart/form-data" }, // axios가 자동으로 처리하지만 명시해도 됨
    })
    .then((res) => res.data);
};

// 시공사진 리스트
export const getPhotoList = (projectId, params = {}) =>
  api.get(`const/photo/${projectId}/`, { params }).then((res) => res.data);

// 시공사진 상세 (pk 필요)
export const getPhotoDetail = (pk) =>
  api.get(`const/photo/detail/${pk}/`).then((res) => res.data);

// 시공사진 수정
export const updatePhoto = (pk, data) =>
  api.put(`const/photo/update/${pk}/`, data).then((res) => res.data);
// 시공사진 삭제
export const deletePhoto = (pk) =>
  api.delete(`const/photo/delete/${pk}/`).then((res) => res.data);

//////////////////////
// 포토보드 리스트
export const getPhotoBoardList = (projectId, params = {}) =>
  api.get(`const/photoboard/${projectId}/`, { params }).then((res) => res.data);

// 포토보드 상세
export const getPhotoBoardDetail = (pk) =>
  api.get(`const/photoboard/detail/${pk}/`).then((res) => res.data);

// 포토보드 생성
export const createPhotoBoard = (data) =>
  api.post(`const/photoboard/create/`, data).then((res) => res.data);

// 포토보드 수정
export const updatePhotoBoard = (pk, data) =>
  api.put(`const/photoboard/update/${pk}/`, data).then((res) => res.data);

// 포토보드 삭제
export const deletePhotoBoard = (pk) =>
  api.delete(`const/photoboard/delete/${pk}/`).then((res) => res.data);

///////////////////////////////////
// 작업지시서
export const getWorkOrderList = (projectId, params = {}) =>
  api.get(`const/workorder/${projectId}/`, { params }).then((res) => res.data);
// 작업지시서 상세
export const getWorkOrderDetail = (pk) =>
  api.get(`const/workorder/detail/${pk}/`).then((res) => res.data);

// 작업지시서 생성
export const createWorkOrder = (data) =>
  api.post(`const/workorder/create/`, data).then((res) => res.data);

// 작업지시서 수정
export const updateWorkOrder = (pk, data) =>
  api.put(`const/workorder/update/${pk}/`, data).then((res) => res.data);

// 작업지시서 삭제
export const deleteWorkOrder = (pk) =>
  api.delete(`const/workorder/delete/${pk}/`).then((res) => res.data);

//////////////////////////////////
// 완료보고서
export const getCompletionReportList = (projectId, params) =>
  api
    .get(`const/completionreport/${projectId}/`, { params })
    .then((res) => res.data);

// 완료보고서 상세
export const getCompletionReportDetail = (pk) =>
  api.get(`const/completionreport/detail/${pk}/`).then((res) => res.data);

// 완료보고서 생성
export const createCompletionReport = (data) =>
  api.post(`const/completionreport/create/`, data).then((res) => res.data);

// 완료보고서 수정
export const updateCompletionReport = (pk, data) =>
  api.put(`const/completionreport/update/${pk}/`, data).then((res) => res.data);

// 완료보고서 삭제
export const deleteCompletionReport = (pk) =>
  api.delete(`const/completionreport/delete/${pk}/`).then((res) => res.data);

// 챗봇
// Todo: 이거 따로 앱으로 만들어야 할듯?
export const getAgentResult = (data) =>
  api.post(`const/agent/`, data).then((res) => res.data);

export const getAgentPageResult = (data) =>
  api.post(`const/agent_page/`, data).then((res) => res.data.answer);

//project 소속 user(test용)
//Todo: 실제 보안 적용된 함수로 사용할것
export const getProjectUsers = (pk) =>
  api.get(`project/${pk}/users/`).then((res) => res.data);

// 상세작업 목록 조회 (프로젝트별)
export const getWorkDetails = (date) =>
  api.get(`const/workdetail/`, { params: { date } }).then((res) => res.data);

// 상세작업 생성
export const createWorkDetail = (data) =>
  api.post(`const/workdetail/create/`, data).then((res) => res.data);

// 상세작업 수정
export const updateWorkDetail = (id, data) =>
  api.put(`const/workdetail/${id}/`, data).then((res) => res.data);

// 상세작업 삭제
export const deleteWorkDetail = (id) =>
  api.delete(`const/workdetail/${id}/`).then((res) => res.data);
